var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-controls",class:{
    'oxy-controls-root': _vm.root
  }},_vm._l((_vm.filteredControls),function(control){return _c('OxygenControl',{key:control.slug,attrs:{"control":control,"path":_vm.path,"value":_vm.syncedValue?.[control.slug]},on:{"input":function($event){return _vm.updateControlValue(control, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }